import React, { useState, useEffect } from 'react'
import { PlanDetailWrapper } from './planDetailStyle'
import { useTypedSelector } from 'src/redux/root-reducer'
import { getMyPlanByIdAction } from 'src/redux/actions/planAction'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import GeneralPlanInfo from './GeneralPlanInfo'
import { GeneralSpinner } from 'src/components/Global/Spinner/Spinner'

const PlanDetail = () => {
  const dispatch = useDispatch()
  const params = useParams()
  const { id } = params

  const [planInfo, setPlanInfo] = useState(null)
  const [fetching, setFetching] = useState(true)

  const Loading = useTypedSelector((state) => state.userPlanReducer.loading)

  // console.log(id)

  useEffect(() => {
    dispatch(getMyPlanByIdAction({ id, onSuccess, onError }))
  }, [dispatch, id])

  const onSuccess = (plan: any) => {
    // console.log(plan)
    setPlanInfo(plan)
    setFetching(false)
  }

  const onError = () => {
    setFetching(false)
  }

  return (
    <PlanDetailWrapper>
      {fetching ? (
        <div className="centerBg"> {Loading && <GeneralSpinner />}</div>
      ) : (
        <>{planInfo && <GeneralPlanInfo plan={planInfo} />}</>
      )}
    </PlanDetailWrapper>
  )
}

export default PlanDetail
